import {
  AcceptanceFormPage,
  CskhPage,
  DanhSachThiPage,
  FoThucDonLayout,
  He,
  HocSinhLayout,
  HocSinhPhuHuynhPage,
  HomePage,
  Khoi,
  KhoiHePage,
  KyThi,
  KyThiMonThi,
  LoaiGiayTo,
  Lop,
  LopHanhChinhPage,
  MonThi,
  NguonBietToiLayout,
  NguonBietToiPage,
  NoiTruLayout,
  PhongThiPage,
  PhuHuynhPage,
  SendEmailLayout,
  SucKhoeLayout,
  SurveyForm,
  SurveyLayout,
  ThangDiem,
  ThiSinh,
  ThongKePage,
  ThongTinCbnvPage,
  TongHopLayout,
  TongHopSucKhoe,
  Truong,
  ThoiHocBaoLuu,
  MonThiDauVaoPage,
  ThiDauVaoPage,
  TrangThaiThiSinhPage,
  KetQuaThiDauVaoPage,
  ThiTuyenSinhLayout,
  QuanLyHoTroLayout,
  AppYeuCauHoTroPage,
  AppYeuCauHoTroDetailPage,
  QuanHePage,
  TinhTrangHonNhanPage,
  TinhNew,
    HotlinePage

} from './pages';
import Faceid from './pages/face-id';
import LichSuXuongPhongYTe from './pages/lich-su-y-te';
import LichSuYTeTypePage from './pages/lich-su-y-te-type';
import TongHopGiayTo from './pages/tong-hop-giay-to';
import BHYTPage from './pages/bhyt';
import DanThuocPage from './pages/dan-thuoc';




const routes = [
  {
    path: "/home/:tab?",
    component: HomePage,
  },
  {
    path: "/dashboard",
    component: ThongKePage,
  },
  {
    path: "/ds_hoc_sinh_lop/:tab?",
    component: LopHanhChinhPage,
  },


  {
    path: "/crm_survey/form/:id",
    component: SurveyForm,
  },
  {
    path: "/crm_survey/:tab?",
    component: SurveyLayout,
  },

  {
    path: "/nguon_biet_toi/:tab?",
    component: NguonBietToiLayout,
  },
  {
    path: "/dm_trangthaihocsinh/:tab?",
    component: HocSinhPhuHuynhPage,
  },
  {
    path: "/loai_giay_to/:tab?",
    component: LoaiGiayTo,
  },
  {
    path: "/nguon_biet_toi/:tab?",
    component: NguonBietToiPage,
  },
  {
    path: "/send-email/:tab?",
    component: SendEmailLayout,
  },
  {
    path: "/hoc-sinh/:tab?",
    component: HocSinhLayout,
  },
  {
    path: "/food/:tab?",
    component: FoThucDonLayout,
  },
  {
    path: "/phu-huynh/:tab?",
    component: PhuHuynhPage,
  },
  {
    path: "/acceptance-form/:tab?",
    component: AcceptanceFormPage,
  },
  {
    path: "/truong/:tab?",
    component: Truong,
  },
  {
    path: "/tinh-new/:tab?",
    component: TinhNew,
  },
  {
    path: "/he/:tab?",
    component: He,
  },
  {
    path: "/khoi/:tab?",
    component: Khoi,
  },
  {
    path: "/khoi_he/:tab?",
    component: KhoiHePage,
  },
  {
    path: "/lop/:tab?",
    component: Lop,
  },
  {
    path: "/suc-khoe/:tab?",
    component: SucKhoeLayout,
  },
  {
    path: "/thang-diem/:tab?",
    component: ThangDiem,
  },
  {
    path: "/mon-thi/:tab?",
    component: MonThi,
  },
  {
    path: '/ky-thi/:tab?',
    component: KyThi
  },
  {
    path: '/thongtin-cbnv/:tab?',
    component: ThongTinCbnvPage,
  },
  {
    path: "/ky-thi",
    component: KyThi,
  },
  {
    path: "kythi-monthi/:tab?",
    component: KyThiMonThi,
  },
  {
    path: "thi-sinh/:tab?",
    component: ThiSinh,
  },
  {
    path: "danh-sach-thi/:tab?",
    component: DanhSachThiPage,
  },
  {
    path: "phong-thi/:tab?",
    component: PhongThiPage,
  },

  {
    path: "/noi-tru/:tab?",
    component: NoiTruLayout,
  },
  {
    path: "/tong-hop/:tab?",
    component: TongHopLayout,
  },

  {
    path: "/tong-hop-giay-to/:tab?",
    component: TongHopGiayTo,
  },
  {
    path: "/tong-hop-suc-khoe/:tab?",
    component: TongHopSucKhoe,
  },
  {
    path: "/face-id/:tab?",
    component: Faceid,
  },
  {
    path: "/cskh/:tab?",
    component: CskhPage,
  },
  {
    path: "/thong-ke",
    component: ThongKePage,
  },
  {
    path: "/thoi-hoc-bao-luu",
    component: ThoiHocBaoLuu,
  },
  {
    path: "/monthidauvao/:tab?",
    component: MonThiDauVaoPage,
  },
  {
    path: "/thidauvao/:tab?",
    component: ThiDauVaoPage,
  },
  {
    path: "/ex_trangthai_thisinh/:tab?",
    component: TrangThaiThiSinhPage,
  },
  {
    path: "/ketqua-thidauvao/:tab?",
    component: KetQuaThiDauVaoPage,
  },
  {
    path: "/thi-tuyen-sinh/:tab?",
    component: ThiTuyenSinhLayout,
  },
  {
    path: "/quan-ly-ho-tro/:tab?",
    component: QuanLyHoTroLayout,
  },
  {
    path: "/app-yeu-cau-ho-tro",
    component: AppYeuCauHoTroPage,
  },
  {
    path: "/app-yeu-cau-ho-tro/:id",
    component: AppYeuCauHoTroDetailPage,
  },
  {
    path: "/quan-he/:tab?",
    component: QuanHePage,
  },
  {
    path: "/tinh-trang-hon-nhan/:tab?",
    component: TinhTrangHonNhanPage,
  },
  {
    path: "/lich-su-xuong-phong-y-te/:tab?",
    component: LichSuXuongPhongYTe,
  },
  {
    path: "/lich-su-y-te-type/:tab?",
    component: LichSuYTeTypePage,
  },
  {
    path: "/hotline/:tab?",
    component: HotlinePage,
  },
  {
    path: "/bhyt/:tab?",
    component: BHYTPage,
  },
    {
    path: '/dan-thuoc',
    component: DanThuocPage
  },
];

export default routes.map((route) => {
  return {
    ...route,
  };
});
